import React, { useMemo, useState } from 'react';
import { MyTeamsLoader } from './MyTeamsLoader';
import { useTranslation } from 'react-i18next';
import { MyTeamsInterface } from '../../interface/RunningActivities.interface';
// ASSETS
import { HiArrowNarrowRight, HiArrowNarrowUp, HiArrowNarrowDown } from 'react-icons/hi';
import { RxDash } from 'react-icons/rx';
import { HomeTeamsContainer } from './MyTeams.style';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'primereact/tooltip';
interface TeamsProps {
	teams: MyTeamsInterface[] | undefined;
	teamsLoading: boolean;
}
const MyTeams = ({ teams, teamsLoading }: TeamsProps) => {
	const [activeTab, setActiveTab] = useState(0);
	const { t } = useTranslation();
	const navigate = useNavigate();

	const tabs = useMemo<string[]>(() => {
		return [
			t('Tournaments'),
			// , t('Champions')
		];
	}, []);
	if (teamsLoading) {
		return <MyTeamsLoader />;
	}

	return (
		<HomeTeamsContainer>
			<div className="home__headers text__default">
				<div className="flex items-center bg-[#01ABC1]">
					{tabs.map((tab, i) => {
						return (
							<div
								key={`teams-${i}`}
								onClick={() => setActiveTab(i)}
								className={`header__toggle__tab w-full text-center font-manropeBold text-white ${
									activeTab === i ? 'bg-[#0C7C8A]' : 'bg-[##01ABC1]'
								} cursor-pointer transition-colors duration-300 ${i === 1 && 'pointer-events-none cursor-default opacity-50'}`}
							>
								{tab}
							</div>
						);
					})}
				</div>
				{teams && teams?.length > 0 ? (
					<div
						className="my__tournaments__ranks text__default tournaments__standing overflow-auto rounded-bl-3xl
					 rounded-br-3xl border bg-white py-2"
					>
						<div>
							<table className="w-full">
								<tbody>
									{teams?.map((d, i) => {
										return (
											<tr key={i} className="group hover:bg-[#0C7C8A1A] hover:text-[#01ABC1]">
												<td
													className={`ps-3 flex items-center justify-start gap-1 font-manropeBold ${d.status === 'up' && 'text-[#65A743]'} ${
														d.status === 'down' && 'text-[#FF4A4A]'
													}`}
												>
													{d.status === 'up' ? <HiArrowNarrowUp /> : d.status === 'down' ? <HiArrowNarrowDown /> : <RxDash />}
													<span className="">{d.rank}</span>
												</td>
												<Tooltip target=".tour__name" />
												<td className="tour__name" data-pr-tooltip={d.name} data-pr-position="top" data-pr-at="left+10 top-5">
													{d.name?.length > 15 ? d.name.slice(0, 12) + '...' : d.name}
												</td>

												<td className="pe-3 flex justify-end text-[#AFAFAF] group-hover:text-[#01ABC1]">
													<HiArrowNarrowRight
														className=" inline cursor-pointer"
														onClick={() => {
															navigate('/tournament', { state: d.slug });
														}}
													/>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</div>
				) : (
					<div className="text__default tournaments__standing flex items-center justify-center rounded-bl-3xl rounded-br-3xl border bg-white p-4 text-center text-lg text-[#afafaf]">
						{t('no_home_teams')}
					</div>
				)}
			</div>
		</HomeTeamsContainer>
	);
};

export default MyTeams;
